export default __webpack_public_path__ + "static/media/gallery-power_00.7682904d.jpg";